import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-requirement-select-history',
  templateUrl: './fes-workflow-action-requirement-select-history.component.html',
  styleUrls: ['./fes-workflow-action-requirement-select-history.component.scss']
})
export class FesWorkflowActionRequirementSelectHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
